<template>
    <span>
      <b-card no-body>
        <b-card-header>
            <b-row>
                 <b-col md="10">
                    <h3>Listar Usuários</h3>
                 </b-col>
                 <b-col md="2">
                    <b-button v-if="can('user.store')" @click="navigate('/usuario/cadastrar')" block variant="primary">
                         <i class="fa fa-plus"></i>
                       <span>Novo Usuário</span>
                    </b-button>
                 </b-col>
            </b-row>
        </b-card-header>
        <b-card-body>
            <b-row>
                <b-col sm="12">
                    <b-form-group label="Nome, E-mail, CPF:">
                        <b-form-input type="text" id="name" v-model="filtros.filter" placeholder="Nome, E-mail, CPF"></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
              <b-col md="3">
                <b-form-group label="Data do cadastro:">
                  <b-input-group>
                    <div class="input-group-prepend">
                    <span class="input-group-text">
                      <i class='fa fa-calendar'></i>
                    </span>
                    </div>
                    <b-form-input id="type-date"
                                  type="date"
                                  v-model.lazy.trim="filtros.consultarData"
                                  ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="2">
                <b-button @click="resetForm()" block>
                    <span>Limpar Filtros</span>
                </b-button>
              </b-col>
            </b-row>
        </b-card-body>
        <b-row>
            <b-col sm="12">
                <b-container fluid>
                       <span>
                          <table aria-rowcount="4" id="my-table" aria-busy="false" aria-colcount="7" class="table table-responsive-sm table-bordered table-striped table-sm">
                          <thead>
                            <tr>
                              <th scope="col">CPF</th>
                              <th scope="col">Nome do Usuário</th>
                              <th scope="col">Perfil do Usuário</th>
                              <th scope="col">Data de Cadastro</th>
                              <th scope="col">Ações</th>
                            </tr>
                          </thead>

                          <tbody v-if="usuarios.data !== undefined">
                            <tr class="action" v-for="usuario in usuarios.data" :key="usuario.id_user">

                              <td>{{usuario.cpf}}</td>
                              <td>{{usuario.nome}}</td>
                              <td>{{usuario.perfil}}</td>
                              <td>{{usuario.created_at}}</td>
                              <td style="width: 15%">
                                  <a v-if="can('user.update')" class="btn btn-sm btn-secondary action" title="Editar" @click="editarUsuario(usuario.id_user)">
                                     <i class="fa fa-pencil-square-o"></i>
                                  </a>

                                  <span>
                                     <a v-if="can('user.destroy') && usuario.id_user !== usuarioCorrente" class="btn btn-sm btn-secondary action" title="Excluir" @click="excluirUsuario(usuario.id_user)">
                                      <i class="fa fa-times"></i>
                                     </a>
                                  </span>

                                  <span>
                                     <a v-if="can('user.show')" class="btn btn-sm btn-secondary action" title="Visualizar" @click="visualizarUsuario(usuario.id_user)">
                                      <i class="fa fa-search"></i>
                                     </a>
                                  </span>
                              </td>
                            </tr>
                          </tbody>
                          <tbody v-else>
                           <tr class="action">
                             <td colspan="9">Nenhum registro de usuários...</td>
                           </tr>
                          </tbody>
                         </table>
                          <pagination v-show="usuarios.data !== undefined" :totalPorPagina="totalPorPagina" :resource="resource"></pagination>
                       </span>
                </b-container>
            </b-col>
        </b-row>
      </b-card>
      <b-modal title="Exclusão do Usuário" size="lg" ok-title="Excluir" cancel-title="Cancelar" v-model="modalPreExcluir" @ok="modalConfirmaExclusao()">
         <b-card-body>
             <b-form>
            <b-row>
              <b-col cols="12">
                <b-form-group label="CPF:">
                  <b-input-group class="mb-6">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="icon-user"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input v-mask="'###.###.###-##'"
                                  id="cpf"
                                  type="text"
                                  :disabled="true"
                                  class="form-control"
                                  placeholder="CPF"
                                  autocomplete="cpf"
                                  v-model="usuario.cpf"
                                  autofocus/>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-form-group label="Nome completo:">
                  <b-input-group class="mb-6">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="icon-user"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="text"
                                  class="form-control"
                                  placeholder="Nome"
                                  autocomplete="nome"
                                  v-model="usuario.nome"
                                  :disabled="true"/>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-form-group label="E-mail:">
                  <b-input-group class="mb-6">
                    <b-input-group-prepend>
                      <b-input-group-text>@</b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="text"
                                  class="form-control"
                                  placeholder="E-mail"
                                  autocomplete="email"
                                  :disabled="true"
                                  v-model.trim="usuario.email"/>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </b-card-body>
      </b-modal>
    </span>
</template>

<script>
import Vue from 'vue'
import Pagination from '@/components/shared/Pagination'
import {eventType} from '@/components/shared/eventType'
import {DatePicker, setupCalendar} from 'v-calendar'
import 'v-calendar/lib/v-calendar.min.css'
import miniToastr from 'mini-toastr'
import SessionStorage from '@/services/session-storage'
import Multiselect from 'vue-multiselect'

setupCalendar({
  firstDayOfWeek: 2 // Monday
})

miniToastr.init()

export default {
  components: {
    Pagination,
    'v-date-picker': DatePicker,
    Multiselect
  },
  created () {
    if (!this.can('user.index')) {
      this.$router.push('/')
    } else {
      this.$store.dispatch('getPerfis')
    }
  },
  data () {
    return {
      usuarioCorrente: parseInt(SessionStorage.get('usuario')),
      totalPorPagina: 10,
      resource: 'usuario',
      modalPreExcluir: false,
      situacoes: [
        { value: '1', text: 'Ativo' },
        { value: '0', text: 'Inativo' }
      ],
      filtros: {
        filter: '',
        consultarData: null
      }
    }
  },
  computed: {
    perfilAtual () {
      return this.$store.state.usuario.perfilAtual
    },
    usuarios () {
      if (this.$store.state.pagination.getList.data !== undefined) {
        if (this.$store.state.pagination.getList.data.length !== 0) {
          return this.$store.state.pagination.getList
        } else {
          return false
        }
      }
      return this.$store.state.pagination.getList
    },
    perfis () {
      return this.$store.state.perfil.lista
    },
    usuario () {
      return this.$store.state.usuario.usuarioEditar
    }
  },
  watch: {
    'filtros.filter': function () {
      this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
    },
    'filtros.consultarData': function () {
      this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
    }
  },
  methods: {
    can (permissao) {
      return this.$store.getters.validaPermissao(permissao)
    },
    resetForm () {
      this.filtros.filter = null
      this.filtros.consultarData = null
    },
    setarFiltros (filtros) {
      eventType.$emit('app', filtros)
    },
    visualizarUsuario (id) {
      this.$router.push('/usuario/' + id + '/visualizar')
    },
    editarUsuario (id) {
      this.$router.push('/usuario/' + id + '/editar')
    },
    excluirUsuario (id) {
      this.titulo_descricao = ''
      this.titulo_confirmacao = ''
      this.titulo_botao = 'Excluir'
      this.tipo = 'excluir'
      this.modalPreExcluir = true
      this.$store.dispatch('getUsuario', id)
    },
    modalConfirmaExclusao () {
      this.$bvModal.msgBoxConfirm('Confirma a exclusão do registro selecionado?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          Vue.http.get('api/usuario/' + this.tipo + '/' + this.usuario.id).then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
            }
          }).catch(erro => {
            if (!erro.body.success) {
              miniToastr.setIcon('error', 'i', {'class': 'fa fa-check'})
              miniToastr.error(erro.body.msg, 'Alerta!', 7000)
              this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
            }
          })
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    navigate (route) {
      this.$router.push(route)
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
    .multiselect.invalid .multiselect__tags,
    .multiselect.invalid .multiselect__tags span,
    .multiselect.invalid .multiselect__tags input {
        background:red;
    }
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/administrador/usuarios/Usuarios.vue